import Vue from 'vue'
import Vuex from 'vuex'

// modules
import auth from './auth'
import user from './user'
import project from './project'
import settings from './settings'
// import lang from './lang'
import services from './services'
import metadata from './metadata'
import keyword from './keyword'
import notifications from './notifications'
import navigation from './navigation'
import subscription from './subscription'
import plan from './plan'
import coupon from './coupon'
import global from './global'
import goal from './goal'
import dashboard from './dashboard'
import discount from './discount'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    user,
    project,
    settings,
    metadata,
    keyword,
    services,
    navigation,
    subscription,
    notifications,
    coupon,
    plan,
    global,
    goal,
    dashboard,
    discount
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js